import { IContent } from 'models/content.model';

export const content: IContent = {
  nl: {
    pageTitle: 'ESPN',
    placeholderTitle: 'ESPN',
    eligibilityError: {
      title: 'ESPN is niet beschikbaar',
      text: 'Je hebt een actief digitaal tv-abonnement nodig en je contract mag niet meer in de minimale looptijd zitten.',
    },
    pause: {
      title: 'Even een pauze',
      content: `
      We merken dat veel mensen benieuwd zijn naar de oplossingen die er zijn. En dat begrijpen we helemaal. Op dit moment is het online erg druk, daarom zetten we deze mogelijkheid even op pauze. Zo zorgen we dat iedereen goed geholpen wordt.
      <br/><br/>
      Wil je toch je vraag stellen of samen naar een oplossing kijken? Bel ons dan op <a href="tel:09001884">0900 - 1884</a> of <a href="tel:1200">1200</a> met een Ziggo-lijn. We spreken je graag.`,
    },
    start: {
      title: 'We willen dat je weer gaat juichen',
      content: `
        Fijn dat je met ons deelt wat je wel en niet wilt.
        <br/>
        We houden je graag verbonden met wat jij wél belangrijk vindt en graag kijkt. Zullen we samen kijken naar een oplossing die bij jou past? Klik op start en volg de instructies om je voorkeuren door te geven. Daarna krijg je een persoonlijk voorstel.`,
      b2bContent: `
        Fijn dat je met ons deelt wat je wel en niet wilt.
        <br/>
        We houden je graag verbonden met wat jij wél belangrijk vindt en graag kijkt. Zullen we samen kijken naar een oplossing die bij jou past? Klik op start en volg de instructies om je voorkeuren door te geven. Daarna krijg je een persoonlijk voorstel.`,
      buttonText: 'Start',
    },
    streamerZapper: {
      title: 'Ben jij een streamer of een zapper?',
      content:
        'Om je het beste aanbod te kunnen doen, willen we weten wat jij het liefste kijkt. Stream je graag een lekkere serie of film? Of zit je liever zappend op de bank tv te kijken?',
      buttonText: 'Doe me een aanbod',
      offerOptions: {
        streamer: 'Ik stream graag',
        zapper: 'Ik zapp graag',
        altijdAlles: 'Verras me maar!',
      },
    },
  },
  en: {},
};
